import React, {Button, Component, useState } from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import _ from '../../utils/languages/languages';
import TextInput from "../../widgets/TextInput";
import FixButton from "../../widgets/Button";
import ManageIntermediary from '../../services/manageIntermediary'
import ImageInput from "../../widgets/ImageInput";
import getIntermediary from "../../services/getIntermediary";

export default class AddIntermediary extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };
  
    this.section = this.props.section
    if (this.section == undefined){
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.userslist = [];

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: false,
      addElementVisible: false,
      intermediaryLogo: null
    }

    this.grid = 2;

    this.pageTitle = "Edit Intermediary";
    this.startDateRef = React.createRef();
    this.endDateRef = React.createRef();

    this.state = {

    };

  }


  async componentDidMount(){

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    const currentIntermediary = cookies.get('currentIntermediary', { path: '/' });

    this.intermediary = await getIntermediary(username, token, currentIntermediary);

    this.setState({
      intermediaryName: this.intermediary.name,
      website: this.intermediary.website,
      username: this.intermediary.username,
      password: '',
      passwordConfirm: '',
    });
  }

  render () {

    function createData(username, name, surname) {
      return { username, name, surname };
    }

    var rows = [];
    this.userslist.length > 0 && this.userslist.map((v, k) => {
      rows.push(createData(v.username, v.name, v.surname));
    });

    return (
      <>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={_.tr('Loading your content...')}
      >
        <PageTitle title={this.pageTitle} />

        <ImageInput name={'Intermediary logo'} key={Math.random()} 
            value={this.state.intermediaryLogo}
            onChange={(val) =>           
              this.setState({intermediaryLogo: val}) }
          />

          <TextInput name={'Intermediary name'} value={this.state.intermediaryName} 
            onChange={(text) => { this.setState({intermediaryName: text})}
          } />
          <TextInput name={'Website'} value={this.state.website} 
            onChange={(text) => { this.setState({website: text})}
          } />
          <TextInput name={'Username'} value={this.state.username} readOnly={true}
            onChange={(text) => { this.setState({username: text})}
          } />
          <TextInput name={'Password'} value={this.state.password} 
            onChange={(text) => { this.setState({password: text})}
          } />
          <TextInput name={'Password confirm'} value={this.state.passwordConfirm} 
            onChange={(text) => { this.setState({passwordConfirm: text})}
          } />

          <FixButton title={'Save'} callback={this.save.bind(this)} />

        </LoadingOverlay>
      </>
    );
  }

  async save (){

    if (this.state.intermediaryName == ''){
      alert ('Check the Intermediary name field');
      return;
    }
    if (this.state.username == ''){
      alert ('Check the Username field');
      return;
    }
    
      const cookies = new Cookies();
      const username = cookies.get('username', { path: '/' });
      const token = cookies.get('token', { path: '/' });
      const intermediaryType = cookies.get('intermediaryType', { path: '/' });
      const currentEventId = cookies.get('currentEventId', { path: '/' });
      const currentIntermediary = cookies.get('currentIntermediary', { path: '/' });

      let res = await ManageIntermediary (username, token, currentIntermediary, currentEventId, intermediaryType, 
                                    this.state.intermediaryName, this.state.intermediaryLogo, this.state.website, this.state.username, this.state.password, false);
                                    
      if (res.result != 'ok'){
        alert ('An error occurred while creating a new intermediary.')
      } else {
        window.location.href = '/#/app/intermediaries';
      }
  }

}

